import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    filter: false,
    sort: '',
}

const filterdsBlogsSlice = createSlice({
    name: "blogs",
    initialState,
    reducers: {
        addFilter: (state, action) =>{
            state.filter = action.payload;
        },
        addSort: (state, action) =>{
            state.sort = action.payload;
        },
        saved: (state, action) =>{
            state.sort = action.payload;
        }
    }
})

export default filterdsBlogsSlice.reducer;
export const {addFilter, addSort} = filterdsBlogsSlice.actions;
